<template>
  <v-card>
    <v-card-title class="primary" dark>
      <h2 class="white--text display-1">
        {{ calendarEvent.name }}
      </h2>
    </v-card-title>
    <v-card-text>
      <p>
        {{ calendarEvent.description }}
      </p>
      <p class="text-xs-right">
        <span v-if="calendarEvent.date" class="ml-3">
          <v-icon>mdi-calendar-blank</v-icon>
          {{ calendarEvent.date | moment('DD/MM/YYYY') }}
        </span>
        <span v-if="calendarEvent.time" class="ml-3">
          <v-icon>mdi-clock-outline</v-icon>
          {{ [calendarEvent.time, 'HH:mm:ss'] | moment('HH:mm') }}
        </span>
      </p>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="$emit('closeDialog')">{{ $t('Ok') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    calendarEvent: {
      type: Object,
    },
  },
};
</script>

<style></style>
